<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <form class="class_add_con w622 col_2_1" data-vv-scope="form" style="min-height: auto;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="left_td">名称：</td>
          <td><input type="text" name="name" v-validate="'required'" placeholder="请输入小组名称" class="put_495" style="width:180px;" v-model="form.name" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.name') }}</div>
        <tr>
          <td class="left_td " valign="top">小组成员：</td>
          <td>
            <dl class="qa_man_add">
              <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
              <dd v-if="list.length > 0">
                <span v-for="item in list" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto;">{{item.name}}</span>
              </dd>
            </dl>
          </td>
        </tr>
        <div class="error_msg">{{ errors.first('form.sort') }}</div>
      </table>
      <div class="add_bt_foot">
        <input name="" type="button" value="保存" @click="validateForm('form')" />
        <input name="" class="hui_color" type="button" value="取消" @click="emit('closed')" />
      </div>
    </form>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import '@/utils/validator.js'
  import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
  import { mapState } from 'vuex'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  import utils from '@/utils'
  import Bus from '@/utils/bus.js'
  export default {
    props: ['data'],
    data () {
      return {
        form: {},
        list: [] // 小组下的人员
      }
    },
    watch: {
      data (val) {
        this.form = val
        this.list = val.groupMembers
        for (let i = 0; i < this.list.length; i++) {
          let o = this.list[i]
          o.name = o.memberName
        }
      }
    },
    created () {
      this.getMenus()
    },
    mounted () {
      this.form.parent = this.dept // 新增状态下将“部门”赋值
    },
    computed: {
      ...mapState('orgstructure', ['dept'])
    },
    methods: {
      emit (msg, p) {
        this.$emit(msg, p)
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          bus.form.list = bus.list
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _dealParams()
            if (bus.form.list && bus.form.list.length > 0) {
              bus.confirmBox({
                yes: function () {
                  bus.$emit('saved', bus.form)
                  bus.$modal.hide('dialog')
                  bus.$emit('closed')
                }
              })
            } else {
              bus.$toasted.show('请为该小组添加成员')
            }
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      show1 () {
        var that = this
        this.$modal.show(TreeSelect, {
          data: that.menus,
          yes: function (val) {
            if (that.form.parent) { delete that.form.parent }
            if (that.form.newparent) { delete that.form.newparent }
            that.$set(that.data, 'newparent', val[0]);
          }
        })
      },
      getMenus (filters) {
        var that = this
        api.post(config.bylApiPath, '/group/groups', null, function (r) { // 获取正常
          that.menus = r.data
        })
      },
      showRange () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '选择小组成员',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.list // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              that.list = val
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              that.list = []
            }
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/group/group.vue